export const scrollTo = id =>
  typeof window !== 'undefined' &&
  document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
